<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ThisForm from "../../../components/payroll/socsosub/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ThisForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('allsocso.monthlysocsosubmissionrecsetup'),
      pageTitleValue: "",
      formData: {
        socsosubreccode: null,
        socsosubrecdesc: null,
        recyear: null,
        recmonth: null,
        aprname: null,
        apricno: null,
        aprtel: null,
        apremail: null,
        aprdesignation: null,
        socsosubrecpay: [],
        socsosubrecref: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      monthList: [],
      yearList: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/socsosubmissionrecord/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "socsosublist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "socsosublist" });
    },
  },
};
</script>